<input
    type="number"
    id="field-{{ field.ID }}"
    class="form-control form-control-sm"
    [(ngModel)]="answer"
    (change)="fieldChange()"
    [disabled]="readonly"
    [readonly]="readonly"
/>
